import { Button } from '~/components';
import { LoadingBar } from './LoadingBar';

interface Props {
  children: React.ReactNode;
}

export const Layout = ({ children }: Props) => {
  return <div className="grid grid-rows-[1fr-1.5fr-1fr] w-full h-full gap-8">{children}</div>;
};

export const Container = ({ children }: Props) => {
  return (
    <div className="grid gap-8grid grid-rows-[1fr-1.65fr-1fr] w-full h-full gap-4">{children}</div>
  );
};

interface HeaderProps {
  title: string;
  subtitle: string;
  cyTag?: string;
}
export const Header = ({ title, subtitle, cyTag }: HeaderProps) => {
  return (
    <div data-cy={cyTag} className="grid grid-rows-[1fr-1.5fr-1fr] w-full h-full gap-2 sm:gap-8">
      <h1 className="text-left font-bold text-[30px] leading-9 sm:text-[43px] sm:leading-10">
        {title}
      </h1>
      <p className="text-left">{subtitle}</p>
    </div>
  );
};

export const FormContent = ({ children }: Props) => {
  return <div className="min-w-0">{children}</div>;
};

interface FooterProps {
  handleBack: () => void;
  loadingPercent?: number;
  cyTags?: {
    back: string;
    loadingBar: string;
  };
}
export const Footer = ({ handleBack, loadingPercent, cyTags }: FooterProps) => {
  const back = '< Back';
  return (
    <div className="grid grid-cols-2 w-full mt-5">
      <button
        type="button"
        data-cy={cyTags?.back}
        onClick={handleBack}
        className="w-14 cursor-pointer justify-start text-grey-300 text-sm font-semibold font-['Inter'] leading-5"
      >
        {back}
      </button>
      {loadingPercent !== undefined && (
        <div className="flex flex-row justify-end items-center mt-2">
          <LoadingBar cyTag={cyTags?.loadingBar} percent={loadingPercent} height={3.5} />
        </div>
      )}
    </div>
  );
};

interface NextProps {
  handleNext?: () => void;
  label?: string;
  cyTag?: string;
}
export const NextButton = ({ handleNext, label, cyTag }: NextProps) => {
  const label_ = label || 'Next';
  return (
    <div className="flex flex-1 justify-end items-end">
      {handleNext ? (
        <Button cyTag={cyTag} colorVariant="translucent" label={label_} onClick={handleNext} />
      ) : (
        <Button cyTag={cyTag} colorVariant="translucent" label={label_} type="submit" />
      )}
    </div>
  );
};
